export const PERSPECTIVES = [
    {
        id: 'volunteers',
        name: 'Volunteers',
        icon: 'users'
    },
    {
        id: 'opportunities',
        name: 'Opportunities',
        icon: 'bars'
    },
];

export const CUSTOM_FIELDS_DATA = {
    volunteers: [
        {
            id: "g1",
            name: "Application Questions",
            "count": 34,
            "fields": [
                {
                    id: "f1",
                    numId: 804,
                    name: "Preferred/Chosen First Name",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 20,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f2",
                    numId: 912,
                    name: "Preferred/Chosen Last Name",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 20,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f3",
                    numId: 887,
                    name: "Email Validation",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 2,
                    desc: ""
                },
                {
                    id: "f4",
                    numId: 995,
                    name: "Age Range",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Under 18",
                        "Over 18"
                    ]
                },
                {
                    id: "f5",
                    numId: 834,
                    name: "Comments",
                    type: "TEXT",
                    multiselect: false,
                    required: false,
                    width: 80,
                    height: 4,
                    desc: "05/24/22: MMacDonald -- Expanded from short text to long text"
                },
                {
                    id: "f6",
                    numId: 792,
                    name: "Emancipated",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Yes",
                        "No"
                    ]
                },
                {
                    id: "f7",
                    numId: 956,
                    name: "Is your Mailing Address the same as your Physical Address?",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Yes",
                        "No"
                    ]
                },
                {
                    id: "f8",
                    numId: 888,
                    name: "Mailing Address",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 2,
                    desc: ""
                },
                {
                    id: "f9",
                    numId: 941,
                    name: "Mailing Address 2",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 20,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f10",
                    numId: 815,
                    name: "Mailing Address City",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f11",
                    numId: 863,
                    name: "Mailing Address State",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA",
                        "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA",
                        "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY",
                        "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX",
                        "UT", "VT", "VA", "WA", "WV", "WI", "WY"
                    ]
                },
                {
                    id: "f12",
                    numId: 907,
                    name: "Mailing Address Zip Code",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f13",
                    numId: 822,
                    name: "If Employee or Volunteer",
                    type: "TEXT",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 4,
                    desc: ""
                },
                {
                    id: "f14",
                    numId: 971,
                    name: "Currently Employed",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Yes",
                        "No"
                    ]
                },
                {
                    id: "f15",
                    numId: 849,
                    name: "Employed Where",
                    type: "TEXT",
                    multiselect: false,
                    required: false,
                    width: 60,
                    height: 1,
                    desc: "2/15/24 - change from \"work experience\" to \"Employed where\""
                },
                {
                    id: "f16",
                    numId: 930,
                    name: "Attending School",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Yes",
                        "No"
                    ]
                },
                {
                    id: "f17",
                    numId: 890,
                    name: "School",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "This is holding the dropdown list for the NG recruiter an is hidden from eC. the value selected by the vol populates the 'School selection' UDF.",
                    options: [
                        "Abraham Lincoln University", "Academy for Jewish Religion-California", "Academy of Art University",
                        "Academy of Chinese Culture and Health Sciences", "Acupuncture and Integrative Medicine College-Berkeley",
                        "Alder Graduate School of Education", "Alhambra Medical University", "Alliant International University-San Diego",
                        "America Evangelical University", "American College of Healthcare Sciences", "American Conservatory Theater",
                        "American Film Institute Conservatory", "American Jewish University", "American Medical Sciences Center",
                        "American University of Health Sciences", "Angeles College", "Antelope Valley College",
                        "Antioch University-Los Angeles", "Antioch University-Santa Barbara", "Antioch University-Seattle",
                        "Art Center College of Design", "Ashford University", "ATI College-Norwalk", "Azusa Pacific University",
                        "Bakersfield College", "Bastyr University", "Bellevue College", "Bellingham Technical College",
                        "Bergin University of Canine Studies", "Berkeley School of Theology", "Bethel Seminary-San Diego",
                        "Bethesda University", "Beverly Hills Design Institute", "Biola University", "Birthingway College of Midwifery",
                        "Brandman University", "Bushnell University", "California Aeronautical University", "California Arts University",
                        "California Baptist University", "California Christian College", "California College of the Arts",
                        "California College San Diego", "California Health Sciences University", "California Institute of Advanced Management",
                        "California Institute of Integral Studies", "California Institute of Technology", "California Institute of the Arts",
                        "California Intercontinental University", "California International Business University", "California Jazz Conservatory",
                        "California Lutheran University", "California Miramar University", "California Polytechnic State University-San Luis Obispo",
                        "California State Polytechnic University-Pomona", "California State University Maritime Academy",
                        "California State University-Bakersfield", "California State University-Channel Islands",
                        "California State University-Chico", "California State University-Dominguez Hills",
                        "California State University-East Bay", "California State University-Fresno", "California State University-Fullerton",
                        "California State University-Long Beach", "California State University-Los Angeles",
                        "California State University-Monterey Bay", "California State University-Northridge",
                        "California State University-Sacramento", "California State University-San Bernardino",
                        "California State University-San Marcos", "California State University-Stanislaus",
                        "California University of Science and Medicine", "California Western School of Law", "Career Networks Institute",
                        "Casa Loma College-Van Nuys", "Cascadia College", "CBD College", "Central Washington University",
                        "Centralia College", "Chamberlain University-California", "Chapman University",
                        "Charles R Drew University of Medicine and Science", "Charter College", "Church Divinity School of the Pacific",
                        "City University of Seattle", "Claremont Graduate University", "Claremont Lincoln University",
                        "Claremont McKenna College", "Claremont School of Theology", "Clark College", "Clover Park Technical College",
                        "Cogswell University of Silicon Valley", "Columbia Basin College", "Columbia College Hollywood",
                        "Concordia University-Irvine", "Corban University", "Cornish College of the Arts", "Cypress College",
                        "Dell'Arte International School of Physical Theatre", "Design Institute of San Diego", "DeVry University-California",
                        "DigiPen Institute of Technology", "Dominican School of Philosophy & Theology", "Dominican University of California",
                        "Dongguk University Los Angeles", "Eastern Oregon University", "Eastern Washington University", "Edmonds College",
                        "Emperor's College of Traditional Oriental Medicine", "Empire College", "Epic Bible College",
                        "Faith International University", "Feather River Community College District",
                        "FIDM-Fashion Institute of Design & Merchandising-Los Angeles", "FIDM-Fashion Institute of Design & Merchandising-San Francisco",
                        "Fielding Graduate University", "Five Branches University", "Foothill College", "Franciscan School of Theology",
                        "Fremont College", "Fresno Pacific University", "Fuller Theological Seminary", "George Fox University",
                        "Glendale Career College", "Gnomon", "Golden Gate University-San Francisco", "Gonzaga University",
                        "Grace Mission University", "Graduate Theological Union", "Grays Harbor College", "Green River College",
                        "Gurnick Academy of Medical Arts", "Harvey Mudd College", "Haven University", "Heritage University",
                        "High Tech High Graduate School of Education", "Highline College", "Holy Names University", "Homestead Schools",
                        "Hope International University", "Humboldt State University", "Humphreys University-Stockton and Modesto Campuses",
                        "Hussian College-Los Angeles", "Institute of Buddhist Studies", "Interior Designers Institute",
                        "International Sports Sciences Association", "International Technological University",
                        "Irell & Manella Graduate School of Biological Sciences at City of Hope", "John Paul the Great Catholic University",
                        "Keck Graduate Institute", "La Sierra University", "Laguna College of Art and Design",
                        "Lake Washington Institute of Technology", "Latin American Bible Institute", "Laurus College", "Lewis & Clark College",
                        "Life Chiropractic College West", "Life Pacific University", "Lincoln University", "Linfield University-McMinnville Campus",
                        "Linfield University-Online and Continuing Education", "Linfield University-School of Nursing", "Loma Linda University",
                        "Los Angeles Academy of Figurative Art", "Los Angeles College of Music", "Los Angeles Film School",
                        "Los Angeles Pacific University", "Lower Columbia College", "Loyola Marymount University", "Marshall B Ketchum University",
                        "Marymount California University", "Medical Allied Career Center", "Menlo College", "Meridian University",
                        "Middlebury Institute of International Studies at Monterey", "Mills College", "MiraCosta College", "Modesto Junior College",
                        "Mount Angel Seminary", "Mount Saint Mary's University", "Multnomah University", "Musicians Institute",
                        "National University", "National University of Natural Medicine", "Naval Postgraduate School",
                        "New Hope Christian College-Eugene", "New York Film Academy", "Newschool of Architecture and Design", "North Seattle College",
                        "Northcentral University", "Northwest College of Art & Design", "Northwest Indian College", "Northwest University",
                        "Northwest University-College of Adult and Professional Studies", "Northwestern Polytechnic University",
                        "Notre Dame de Namur University", "Oak Valley College", "Occidental College", "Olympic College",
                        "Oregon College of Oriental Medicine", "Oregon Health & Science University", "Oregon Institute of Technology",
                        "Oregon State University", "Oregon State University-Cascades Campus", "Otis College of Art and Design",
                        "Pacific Bible College", "Pacific College", "Pacific College of Health and Science", "Pacific Lutheran University",
                        "Pacific Northwest College of Art", "Pacific Northwest University of Health Sciences", "Pacific Oaks College",
                        "Pacific School of Religion", "Pacific States University", "Pacific Union College", "Pacific University",
                        "Pacifica Graduate Institute", "Palo Alto University", "Pardee RAND Graduate School", "Pathways College", "PCI College",
                        "Peninsula College", "Pepperdine University", "Pierce College District", "Pitzer College", "Platt College-Anaheim",
                        "Platt College-Los Angeles", "Platt College-Ontario", "Platt College-Riverside", "Platt College-San Diego",
                        "Point Loma Nazarene University", "Pomona College", "Portland State University", "Presbyterian Theological Seminary in America",
                        "Presidio Graduate School", "Providence Christian College", "Reed College", "Reiss-Davis Graduate School",
                        "Renton Technical College", "Rio Hondo College", "SAE Expression College", "Saint Martin's University",
                        "Saint Mary's College of California", "Samuel Merritt University", "San Diego Christian College",
                        "San Diego Global Knowledge University", "San Diego Mesa College", "San Diego State University", "San Francisco Art Institute",
                        "San Francisco Conservatory of Music", "San Francisco State University", "San Joaquin College of Law",
                        "San Joaquin Valley College-Visalia", "San Jose State University", "Sanford Burnham Prebys Medical Discovery Institute",
                        "Santa Ana College", "Santa Barbara Business College-Bakersfield", "Santa Barbara Business College-Santa Maria",
                        "Santa Clara University", "Santa Monica College", "Saybrook University", "Scripps College", "Seattle Central College",
                        "Seattle Film Institute", "Seattle Institute of East Asian Medicine", "Seattle Pacific University", "Seattle University",
                        "Shasta Bible College and Graduate School", "Shasta College", "Simpson University", "Skagit Valley College",
                        "Sofia University", "Soka University of America", "Solano Community College", "Sonoma State University",
                        "South Baylo University", "South Seattle College", "Southern California Institute of Architecture",
                        "Southern California Institute of Technology", "Southern California Seminary", "Southern California University of Health Sciences",
                        "Southern Oregon University", "Southern States University", "Southwestern Law School", "Spokane Community College",
                        "Spokane Falls Community College", "St John's Seminary", "Stanbridge University", "Stanford University",
                        "Starr King School for the Ministry", "SUM Bible College and Theological Seminary", "Sumner College", "Tacoma Community College",
                        "Teachers College of San Joaquin", "The Chicago School of Professional Psychology at Anaheim",
                        "The Chicago School of Professional Psychology at Los Angeles", "The Chicago School of Professional Psychology at San Diego",
                        "The Evergreen State College", "The Master's University and Seminary",
                        "The Santa Barbara and Ventura Colleges of Law at Santa Barbara", "The Santa Barbara and Ventura Colleges of Law at Ventura",
                        "The Seattle School of Theology & Psychology", "The University of America", "The Wright Institute", "Thomas Aquinas College",
                        "Thomas Jefferson School of Law", "Touro University California", "Touro University Worldwide", "Trinity Law School",
                        "United States University", "Unitek College", "University of Antelope Valley", "University of California-Berkeley",
                        "University of California-Davis", "University of California-Hastings College of Law", "University of California-Irvine",
                        "University of California-Los Angeles", "University of California-Merced", "University of California-Riverside",
                        "University of California-San Diego", "University of California-San Francisco", "University of California-Santa Barbara",
                        "University of California-Santa Cruz", "University of East-West Medicine", "University of La Verne", "University of Oregon",
                        "University of Phoenix-California", "University of Portland", "University of Puget Sound", "University of Redlands",
                        "University of Saint Katherine", "University of San Diego", "University of San Francisco", "University of Southern California",
                        "University of St. Augustine for Health Sciences", "University of the Pacific", "University of the People",
                        "University of the West", "University of Washington-Bothell Campus", "University of Washington-Seattle Campus",
                        "University of Washington-Tacoma Campus", "University of West Los Angeles", "University of Western States",
                        "Vanguard University of Southern California", "Walla Walla Community College", "Walla Walla University",
                        "Warner Pacific University", "Warner Pacific University Professional and Graduate Studies", "Washington State University",
                        "Wenatchee Valley College", "West Coast Ultrasound Institute", "West Coast University-Center for Graduate Studies",
                        "West Coast University-Los Angeles", "West Coast University-Ontario", "West Coast University-Orange County",
                        "West Los Angeles College", "Westcliff University", "Western Oregon University", "Western Seminary",
                        "Western University of Health Sciences", "Western Washington University", "Westminster Theological Seminary in California",
                        "Westmont College", "Whatcom Community College", "Whitman College", "Whittier College", "Whitworth University",
                        "Whitworth University-Adult Degree Programs", "Willamette University", "William Jessup University", "Woodbury University",
                        "World Mission University", "Yeshiva Ohr Elchonon Chabad West Coast Talmudical Seminary",
                        "Yo San University of Traditional Chinese Medicine", "Zaytuna College", "Other"
                    ]
                },
                {
                    id: "f18",
                    numId: 809,
                    name: "Volunteer Experience",
                    type: "TEXT",
                    multiselect: false,
                    required: false,
                    width: 60,
                    height: 4,
                    desc: ""
                },
                {
                    id: "f19",
                    numId: 881,
                    name: "Other Skills",
                    type: "TEXT",
                    multiselect: false,
                    required: false,
                    width: 60,
                    height: 4,
                    desc: ""
                },
                {
                    id: "f20",
                    numId: 795,
                    name: "Interests",
                    type: "TEXT",
                    multiselect: false,
                    required: false,
                    width: 60,
                    height: 4,
                    desc: ""
                },
                {
                    id: "f21",
                    numId: 918,
                    name: "Gain from Volunteering",
                    type: "TEXT",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 4,
                    desc: ""
                },
                {
                    id: "f22",
                    numId: 870,
                    name: "Placement Preference",
                    type: "TEXT",
                    multiselect: false,
                    required: false,
                    width: 60,
                    height: 4,
                    desc: ""
                },
                {
                    id: "f23",
                    numId: 988,
                    name: "How heard",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Print Advertisement",
                        "Recruitment Event",
                        "Website",
                        "Search Engine",
                        "Social Media",
                        "Word of Mouth: KP Staff Member",
                        "Word of Mouth: KP Volunteer",
                        "Other"
                    ]
                },
                {
                    id: "f24",
                    numId: 820,
                    name: "How heard date",
                    type: "DATE",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: ""
                },
                {
                    id: "f25",
                    numId: 962,
                    name: "How heard location",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 2,
                    desc: ""
                },
                {
                    id: "f26",
                    numId: 895,
                    name: "Timeframe",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "6 months",
                        "1 year",
                        "Other"
                    ]
                },
                {
                    id: "f27",
                    numId: 947,
                    name: "If other, timeframe",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 60,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f28",
                    numId: 811,
                    name: "Scheduling Limits",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 60,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f29",
                    numId: 982,
                    name: "Hospice | Grieving Death",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Yes",
                        "No"
                    ]
                },
                {
                    id: "f30",
                    numId: 875,
                    name: "Hospice | Grieving Death Date",
                    type: "DATE",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: ""
                },
                {
                    id: "f31",
                    numId: 939,
                    name: "Hospice | Availability",
                    type: "LIST",
                    multiselect: true,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Evenings",
                        "Days",
                        "Weekends"
                    ]
                },
                {
                    id: "f32",
                    numId: 855,
                    name: "School Selection",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 2,
                    desc: ""
                },
                {
                    id: "f33",
                    numId: 999,
                    name: "MRN",
                    type: "NUMBER",
                    multiselect: false,
                    required: false,
                    width: 12,
                    height: "",
                    desc: ""
                },
                {
                    id: "f34",
                    numId: 801,
                    name: "Other School",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 1,
                    desc: ""
                }
            ]
        },
        {
            id: "g2",
            name: "Emergency Contacts",
            "count": 12,
            "fields": [
                {
                    id: "f1",
                    numId: 915,
                    name: "Contact 1 Name",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 15,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f2",
                    numId: 803,
                    name: "Contact 1 Cell Phone",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 15,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f3",
                    numId: 791,
                    name: "Contact 1 Home Phone",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 15,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f4",
                    numId: 992,
                    name: "Contact 1 Work Phone",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 15,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f5",
                    numId: 834,
                    name: "Contact 1 Relationship",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Spouse/Partner",
                        "Parent",
                        "Child (over the age of 18)",
                        "Relative",
                        "Friend",
                        "Other"
                    ]
                },
                {
                    id: "f6",
                    numId: 887,
                    name: "Contact 1 Email",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f7",
                    numId: 921,
                    name: "Contact 2 Name",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 15,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f8",
                    numId: 978,
                    name: "Contact 2 Cell Phone",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 15,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f9",
                    numId: 845,
                    name: "Contact 2 Home Phone",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 15,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f10",
                    numId: 909,
                    name: "Contact 2 Relationship",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Spouse/Partner",
                        "Parent",
                        "Child (over the age of 18)",
                        "Relative",
                        "Friend",
                        "Other"
                    ]
                },
                {
                    id: "f11",
                    numId: 866,
                    name: "Contact 2 Email",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 50,
                    height: 1,
                    desc: ""
                },
                {
                    id: "f12",
                    numId: 812,
                    name: "Contact 2 Work Phone",
                    type: "STRING",
                    multiselect: false,
                    required: false,
                    width: 15,
                    height: 1,
                    desc: ""
                }
            ]
        },
        {
            id: "g5",
            name: "Settings",
            "count": 9,
            "fields": [
                {
                    id: "f1",
                    numId: 933,
                    name: "Is an adult",
                    type: "BOOLEAN",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "Set if age range is over 18 or if volunteer is under 18 and emanicipated"
                },
                {
                    id: "f2",
                    numId: 880,
                    name: "Test Record",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: ""
                },
                {
                    id: "f3",
                    numId: 795,
                    name: "Completed first Workflow",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: ""
                },
                {
                    id: "f4",
                    numId: 988,
                    name: "Onboarding/Applicant Reason",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "New/Applicant",
                        "Onboarding In Progress",
                        "Under Review",
                        "Accepted"
                    ]
                },
                {
                    id: "f5",
                    numId: 857,
                    name: "Discontinued Reason",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Never Placed",
                        "Incomplete",
                        "Deceased",
                        "Dismissed w Cause",
                        "Dismissed w/out Cause",
                        "Rejected",
                        "Resigned"
                    ]
                },
                {
                    id: "f6",
                    numId: 901,
                    name: "Terminated w Cause Reason",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: ""
                },
                {
                    id: "f7",
                    numId: 822,
                    name: "Inactive Reason",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Personal",
                        "Medical",
                        "School",
                        "Unknown",
                        "LOA"
                    ]
                },
                {
                    id: "f8",
                    numId: 964,
                    name: "Compliance Flag",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: "",
                    options: [
                        "Compliant",
                        "Non-compliant"
                    ]
                },
                {
                    id: "f9",
                    numId: 810,
                    name: "One Time Event",
                    type: "LIST",
                    multiselect: false,
                    required: false,
                    width: "",
                    height: "",
                    desc: ""
                }
            ]
        }
    ],
    opportunities: [],
};

export const INITIAL_DATA = [
    {
        id: 'contact-info',
        title: 'Contact Info',
        isOpen: true,
        fields: [
            {
                id: 'f15',
                label: 'First Name',
                value: 'Anthony',
                type: 'text',
                required: true,
                colSpan: 1
            },
            {
                id: 'f16',
                label: 'Middle Name',
                value: 'Edward',
                type: 'text',
                required: true,
                colSpan: 1
            },
            {
                id: 'f17',
                label: 'Last Name',
                value: 'Stark',
                type: 'text',
                required: true,
                colSpan: 1
            },
            {
                id: 'f22',
                label: 'Preferred Name',
                value: 'Tony',
                type: 'text',
                colSpan: 1
            },
            {
                id: 'f19',
                label: 'Email',
                value: 'tony@starkindustries.com',
                type: 'email',
                colSpan: 1
            },
            {
                id: 'f21',
                label: 'Phone',
                value: '310-457-1000',
                type: 'text',
                colSpan: 1
            },
            {
                id: 'f23',
                label: 'Work Phone',
                value: '212-970-4133',
                type: 'text',
                colSpan: 1
            },
            {
                id: 'f20',
                label: 'Contact Preferences',
                value: 'Email, Phone',
                type: 'text',
                colSpan: 1
            },
            {
                id: 'f18',
                label: 'Address',
                value: '10880 Malibu Point, 90265',
                type: 'textarea',
                colSpan: 1
            },
        ]
    },
    {
        id: 'app-questions',
        title: 'Application Questions',
        isOpen: false,
        fields: [
            {
                id: 'f1',
                label: 'Preferred/Chosen First Name (#804)',
                value: 'Tony',
                type: 'text',
                colSpan: 1
            },
            {
                id: 'f2',
                label: 'Preferred/Chosen Last Name (#912)',
                value: 'Stark',
                type: 'text',
                colSpan: 1
            },
            {
                id: 'f4',
                label: 'Age Range (#995)',
                value: 'Over 18',
                type: 'select',
                options: ['Under 18', 'Over 18'],
                colSpan: 1
            },
            {
                id: 'f5',
                label: 'Comments (#834)',
                value: 'A little narcissistic but enthusiastic.',
                type: 'textarea',
                colSpan: 1
            },
            {
                id: 'f7',
                label: 'Mailing Address same as Physical Address? (#956)',
                value: 'Yes',
                type: 'select',
                options: ['Yes', 'No'],
                colSpan: 1
            },
            {
                id: 'f14',
                label: 'Currently Employed (#971)',
                value: 'Yes',
                type: 'select',
                options: ['Yes', 'No'],
                colSpan: 1
            },
            {
                id: 'f15',
                label: 'Employed Where (#849)',
                value: 'Stark Industries',
                type: 'text',
                colSpan: 1
            },
            {
                id: 'f23',
                label: 'How heard (#988)',
                value: 'Website',
                type: 'select',
                options: [
                    "Print Advertisement",
                    "Recruitment Event",
                    "Website",
                    "Search Engine",
                    "Social Media",
                    "Word of Mouth: KP Staff Member",
                    "Word of Mouth: KP Volunteer",
                    "Other"
                ],
                colSpan: 1
            },
            {
                id: 'f33',
                label: 'SSN (#999)',
                value: '12345678',
                type: 'number',
                colSpan: 1,
                // Mocking the error state seen in the screenshot
                error: 'Invalid SSN format.',
                isEditing: true
            },
            {
                id: 'f31',
                label: 'Hospice | Availability (#939)',
                value: ['Evenings'],
                type: 'list',
                multiselect: true,
                options: ['Evenings', 'Days', 'Weekends'],
                colSpan: 1
            }
        ]
    },
    {
        id: 'settings',
        title: 'Settings',
        isOpen: false,
        fields: [
            {
                id: 'f1',
                label: 'Is an adult (#933)',
                value: true,
                type: 'boolean',
                colSpan: 1
            },
            {
                id: 'f2',
                label: 'Test Record (#880)',
                value: '',
                type: 'list',
                colSpan: 1
            },
            {
                id: 'f3',
                label: 'Completed first Workflow (#795)',
                value: '',
                type: 'list',
                colSpan: 1
            },
            {
                id: 'f4',
                label: 'Onboarding/Applicant Reason (#988)',
                value: 'Accepted',
                type: 'select',
                options: [
                    "New/Applicant",
                    "Onboarding In Progress",
                    "Under Review",
                    "Accepted"
                ],
                colSpan: 1
            },
            {
                id: 'f5',
                label: 'Discontinued Reason (#857)',
                value: '',
                type: 'select',
                options: [
                    "Never Placed",
                    "Incomplete",
                    "Deceased",
                    "Dismissed w Cause",
                    "Dismissed w/out Cause",
                    "Rejected",
                    "Resigned"
                ],
                colSpan: 1
            },
            {
                id: 'f6',
                label: 'Terminated w Cause Reason (#901)',
                value: '',
                type: 'list',
                colSpan: 1
            },
            {
                id: 'f7',
                label: 'Inactive Reason (#822)',
                value: '',
                type: 'select',
                options: [
                    "Personal",
                    "Medical",
                    "School",
                    "Unknown",
                    "LOA"
                ],
                colSpan: 1
            },
            {
                id: 'f8',
                label: 'Compliance Flag (#964)',
                value: 'Compliant',
                type: 'select',
                options: [
                    "Compliant",
                    "Non-compliant"
                ],
                colSpan: 1
            },
            {
                id: 'f9',
                label: 'One Time Event (#810)',
                value: '',
                type: 'list',
                colSpan: 1
            }
        ]
    },
    {
        id: "g4",
        title: "Emergency Contacts",
        isOpen: false,
        fields: [
            {
                id: "f1",
                label: "Contact 1 Name (#915)",
                value: "Pepper Potts",
                type: "text",
                required: false,
                colSpan: 1
            },
            {
                id: "f2",
                label: "Contact 1 Cell Phone (#803)",
                value: "310-555-1234",
                type: "text",
                required: false,
                colSpan: 1
            },
            {
                id: "f3",
                label: "Contact 1 Home Phone (#791)",
                value: "310-555-5678",
                type: "text",
                required: false,
                colSpan: 1
            },
            {
                id: "f4",
                label: "Contact 1 Work Phone (#992)",
                value: "212-970-4133",
                type: "text",
                required: false,
                colSpan: 1
            },
            {
                id: "f5",
                label: "Contact 1 Relationship (#834)",
                value: "Spouse/Partner",
                type: "select",
                required: false,
                colSpan: 1,
                options: ["Spouse/Partner", "Parent", "Child (over the age of 18)", "Relative", "Friend", "Other"]
            },
            {
                id: "f6",
                label: "Contact 1 Email (#887)",
                value: "pepper.potts@starkindustries.com",
                type: "text",
                required: false,
                colSpan: 1
            },
            {
                id: "f7",
                label: "Contact 2 Name (#921)",
                value: "Happy Hogan",
                type: "text",
                required: false,
                colSpan: 1
            },
            {
                id: "f8",
                label: "Contact 2 Cell Phone (#978)",
                value: "310-555-8765",
                type: "text",
                required: false,
                colSpan: 1
            },
            {
                id: "f9",
                label: "Contact 2 Home Phone (#845)",
                value: "",
                type: "text",
                required: false,
                colSpan: 1
            },
            {
                id: "f10",
                label: "Contact 2 Relationship (#909)",
                value: "Friend",
                type: "select",
                required: false,
                colSpan: 1,
                options: ["Spouse/Partner", "Parent", "Child (over the age of 18)", "Relative", "Friend", "Other"]
            },
            {
                id: "f11",
                label: "Contact 2 Email (#866)",
                value: "happy.hogan@starkindustries.com",
                type: "text",
                required: false,
                colSpan: 1
            },
            {
                id: "f12",
                label: "Contact 2 Work Phone (#812)",
                value: "212-970-4133",
                type: "text",
                required: false,
                colSpan: 1
            }
        ]
    }
];
